export const LOQATE_FIND_URL =
    "https://api.addressy.com/Capture/Interactive/Find/v1.10/json3.ws"
export const LOQATE_RETRIEVE_URL =
    "https://api.addressy.com/Capture/Interactive/Retrieve/v1.20/json3.ws"
export const LOQATE_VERIFY_URL =
    "https://api.addressy.com/Cleansing/International/Batch/v1.20/json6.ws"

/** Suggestions shown in the dropdown before the customer has to keep typing. */
export const LOQATE_FIND_LIMIT = 7

/** Runs with the submit button disabled, so a hang has to be cut off. */
export const LOQATE_VERIFY_TIMEOUT_MS = 3_000
/** Breather before the one retry, so an instant second call does not hit the same limit. */
export const LOQATE_VERIFY_RETRY_DELAY_MS = 300
/** Backstop for the browser's call to our route, which spends two attempts upstream. */
export const LOQATE_VERIFY_CLIENT_TIMEOUT_MS = 10_000

/**
 * The as-you-type dropdown, the only caller of Find and Retrieve. Off at this one point so
 * it can come back as a one-line change. Verify ignores this flag.
 */
export const ADDRESS_AUTOCOMPLETE_ENABLED = false
